<template>
  <div>
    <v-breadcrumbs class="pa-4" :items="breadcrumb" large></v-breadcrumbs>

    <v-card :loading="loading">
      <v-card-title class="mb-0 pb-0">{{ get(notification, 'data.title') }}</v-card-title>
      <v-card-text class="my-0 py-0">
        <small>{{ get(notification, 'data.created_at') }}</small>
      </v-card-text>

      <v-card-text>{{ get(notification, 'data.body') }}</v-card-text>

      <v-card-text v-if="get(notification, 'data.review')">
        <card-review :firebase-ref="`/reviews/${get(notification, 'data.review.review_id')}`" :review="get(notification, 'data.review')" />
      </v-card-text>

      <v-card-text v-if="get(notification, 'data.task')">
        <card-task :task="get(notification, 'data.task')"></card-task>
      </v-card-text>
    </v-card>

    <v-snackbar
        v-model="snackbar.show"
        timeout="3000"
        :color="snackbar.color"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {handleResponseError} from '@/api/handleError'
import { get } from 'lodash'
import CardReview from '@/views/Reviews/CardReview'
import CardTask from '@/views/Tasks/CardTask'

export default {
  name: 'Notification',
  computed: {
    ...mapState({
      notification: state => state.notifications.notification
    }),
    get() {
      return get
    },
  },
  components: {
    CardReview,
    CardTask
  },
  methods: {
    fetchNotification: async function() {
      this.loading = true
      await this.$store.dispatch('notifications/getNotification', this.id).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar a notificação.')
        this.showNotification(message, 'red darken-2')
        this.loading = false
      })
      this.loading = false
    },
    showNotification: function(message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
  },
  created() {
    const id = this.$route.params.id
    if (!id) {
      this.showNotification('Nenhuma notificação encontrada', 'red darken-2')
    } else {
      this.id = id
      this.fetchNotification()
    }
  },
  data: () => ({
    id: null,
    loading: false,
    breadcrumb: [
      {
        text: 'Notificações',
        disabled: false,
        href: '/notifications',
      },
      {
        text: 'Detalhes da notificação',
        disabled: true,
        href: '',
      }
    ],
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    }
  })
}
</script>

<style scoped>

</style>